/**
 * PFR "dinamika" — MODEL_GUIDE 2-band: turg'un model uchun `step` = har qadamda
 * `steady` + holatga vaqt. Haqiqiy plug-flow o'tish jarayoni (kirish o'zgarishining
 * reaktor bo'ylab τ vaqt ichida "siljishi", hajm bo'ylab PDE) 1-versiyada
 * modellashtirilmagan: chiqish kirish o'zgarishiga oniy javob beradi.
 * ASSUMPTION: kvazi-turg'un rejim (kirishlar τ ga nisbatan sekin o'zgaradi).
 */
import type { StepResult } from '../../types';
import { solveSteady, validatePfrInputs, validatePfrParams } from './steady';
import type { PfrInputs, PfrParams, PfrState, PfrStepOutputs } from './types';

export function initState(p: PfrParams, inputs: PfrInputs): PfrState {
  validatePfrParams(p);
  validatePfrInputs(p, inputs);
  return { t: 0 };
}

export function stepDynamic(
  p: PfrParams,
  state: PfrState,
  inputs: PfrInputs,
  dt: number,
): StepResult<PfrState, PfrStepOutputs> {
  if (!(dt > 0)) throw new Error('pfr: dt must be > 0');
  const r = solveSteady(p, inputs);
  const t = state.t + dt;
  return { state: { t }, outputs: { ...r.outputs, t }, warnings: r.warnings };
}
